import React from "react";
import Contact from "../../components/contact";

const ContactPage = () => {

    return (
        <div>
            <Contact />
        </div>
    );
}

export default ContactPage;